import { render } from "./thisOrThatThree.vue?vue&type=template&id=5b6a3cc7"
import script from "./thisOrThatThree.vue?vue&type=script&lang=js"
export * from "./thisOrThatThree.vue?vue&type=script&lang=js"

import "./thisOrThatThree.vue?vue&type=style&index=0&id=5b6a3cc7&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__